export default __webpack_public_path__ + "static/media/et-ga.b1e3b377.svg";